import React, { memo } from 'react';

export const N8NLogo = memo<{ size?: number }>(({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="100" height="100" rx="20" fill="#EA4B71" />
    <text x="50" y="65" fontFamily="Arial" fontSize="48" fontWeight="bold" fill="white" textAnchor="middle">n8n</text>
  </svg>
));
N8NLogo.displayName = 'N8NLogo';

export const ZapierLogo = memo<{ size?: number }>(({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="100" height="100" rx="20" fill="#FF4A00" />
    <path d="M30 50L50 30L70 50L50 70L30 50Z" fill="white" />
    <path d="M40 50L50 40L60 50L50 60L40 50Z" fill="#FF4A00" />
  </svg>
));
ZapierLogo.displayName = 'ZapierLogo';

export const MakeLogo = memo<{ size?: number }>(({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="100" height="100" rx="20" fill="#6D00CC" />
    <circle cx="30" cy="50" r="8" fill="white" />
    <circle cx="50" cy="30" r="8" fill="white" />
    <circle cx="50" cy="70" r="8" fill="white" />
    <circle cx="70" cy="50" r="8" fill="white" />
    <line x1="30" y1="50" x2="50" y2="30" stroke="white" strokeWidth="4" />
    <line x1="30" y1="50" x2="50" y2="70" stroke="white" strokeWidth="4" />
    <line x1="50" y1="30" x2="70" y2="50" stroke="white" strokeWidth="4" />
    <line x1="50" y1="70" x2="70" y2="50" stroke="white" strokeWidth="4" />
  </svg>
));
MakeLogo.displayName = 'MakeLogo';
